const USAGE_ALERT_LIMITS = {
  CRITICAL: 0,
  WARNING: 3,
}

export { USAGE_ALERT_LIMITS }
